import React from 'react';
import styled from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../Item';
import { CHART_POLAR } from '../itemIds';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
  Plugin
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

interface ItemDef {
  title: string;
  subtitle: string;
  body: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  items: Array<ItemDef>;
}

const Wrapper = styled.divBox`
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  padding-bottom: 30px;
  width: 100%;
`;

export class ChartPolar extends Item<typeof CHART_POLAR, Props> {
  protected render({ title, subtitle, items }: RenderProps<Props>) {
    const labels: string[] = [];
    const dataForChart: number[] = [];
    const backgroundColor: string[] = [];
    const borderColor: string[] = [];
    const ariaLabel: string[] = [];

    if (items && items.length) {
      items.forEach((item: ItemDef) => {
        labels.push(item?.title);
        dataForChart.push(Number(item?.subtitle));

        ariaLabel.push(`${item?.title}: ${item?.subtitle}`);

        const colors = item?.body?.replace(/<\/?[^>]+(>|$)/g, '')?.split(',');
        if (colors && colors[0]) {
          backgroundColor.push(colors[0]);
        }
        if (colors && colors[1]) {
          borderColor.push(colors[1]);
        }
      });
    }

    const data = {
      labels: labels,
      datasets: [
        {
          label: title,
          data: dataForChart,
          backgroundColor: backgroundColor,
          borderWidth: 1
        }
      ]
    };

    const options = {
      plugins: {
        datalabels: {
          display: true,
          weight: 'bold',
          color: '#FFF',
          font: {
            size: 22
          }
        }
      }
    };

    return (
      <Wrapper>
        <PolarArea
          data={data}
          aria-label={ariaLabel.join(', ')}
          role="img"
          plugins={[ChartDataLabels] as Plugin<'polarArea'>[]}
          options={options}
        />
      </Wrapper>
    );
  }
}

registry[CHART_POLAR] = ChartPolar;
